import { of, switchMap, tap, catchError } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './view.js';
import { dishes$ } from './api.js';
import { formatApiErrorMessage } from './api.js';
import { showErrorBanner } from './dom.js';

export function createDishesView() {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('dishes-view');
            replaceViewContainer(root);

            let renderDishes$ = dishes$.pipe(
                tap((dishes) => {
                    let container = root.querySelector('.dishes-container');
                    container.innerHTML = '';
                    root.querySelector('.loading').classList.add('hidden');
                    for (let dish of dishes) {
                        let li = document.createElement('li');
                        li.textContent = dish.title;
                        container.appendChild(li);
                    }
                }),
                catchError((err) => {
                    showErrorBanner(root, formatApiErrorMessage(err));
                    throw err;
                })
            );

            return renderDishes$;
        })
    );
}
